import { theme, Typography } from "antd";
import { Development } from "../../../assets";
import {
  ColumnComponent,
  ContainerComponent,
  RowComponent,
} from "../../../components";

export const MetricPartial = ({
  label = "label",
  color = "#33395D",
  icon = <Development size={32} color="black" />,
  data = "Data here",
  style,
}) => {
  const {
    token: { colorTextTertiary },
  } = theme.useToken();
  return (
    <RowComponent
      style={{
        flex: "1 1 200px",
        margin: "0 8px 16px",
        ...style,
      }}
    >
      <ContainerComponent
        style={{
          alignItems: "center",
          backgroundColor: color,
          borderRadius: 32,
          padding: 16,
          height: "fit-content",
        }}
      >
        {icon}
      </ContainerComponent>
      <ColumnComponent
        style={{
          marginLeft: 16,
          width: "fit-content",
          textAlign: "start",
        }}
      >
        <Typography.Title level={5} style={{ margin: 0 }}>
          {data || "Sin datos"}
        </Typography.Title>
        <Typography.Text style={{ color: colorTextTertiary, fontWeight: 500 }}>
          {label}
        </Typography.Text>
      </ColumnComponent>
    </RowComponent>
  );
};
